<template>
  <div style="max-height: 400px; overflow-y: auto; width: 100%">
    <canvas ref="canvas" height="400"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js';

export default {
  name: 'HorizontalBarChart',
  props: {
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chart: null
    };
  },
  watch: {
    chartData: {
      handler() {
        this.updateChart();
      },
      deep: true
    }
  },
  mounted() {
    this.renderChart();
  },
  methods: {
    getDefaultOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        scales: {
          xAxes: [
            {
              ticks: { beginAtZero: true }
            }
          ],
          yAxes: [
            {
              ticks: {
                mirror: false,
                padding: 10
              }
            }
          ]
        }
      };
    },
    renderChart() {
      this.chart = new Chart(this.$refs.canvas, {
        type: 'horizontalBar',
        data: this.chartData,
        options: this.getDefaultOptions()
      });
    },
    updateChart() {
      if (this.chart) {
        this.chart.data = this.chartData;
        this.chart.options = this.getDefaultOptions();
        this.chart.update();
      }
    }
  }
};
</script>
